<template>
  <v-container class="mt-n2 table-container">
      <v-card class="elevation-0 mt-n2 size-card-calendar">
        <v-card-title class="calendar-title">
            <v-layout row grap >
                <v-row class="row-calendar">
                    <v-col cols="7" sm="9" md="10" lg="10" class="stat-col">
                        <v-row class="statistics-for-date mt-2">
                        <p 
                            color="#333"
                            class="mr-3 statisticsForDate"
                            text
                            @click="showCalendar = !showCalendar"
                        >
                            {{$t('statisticsForTheDate')}}
                        </p>
                        <p class="date">{{fromDate()}}
                            <span v-if="startDate !== '' && range !== 'day' && range !== ''"> 
                                <span class="statisticsForDate" color="#000">hasta</span> 
                            {{toDate()}}
                            </span>
                        </p>
                        </v-row>
                    </v-col>
                    <v-col cols="3" sm="2" md="2" lg="2" class="calendar-col">
                        <v-row class="statistics-for-date statistics-for-date-calendar">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-img 
                                        :src="calendar" 
                                        max-width="35" 
                                        class="img-icon pb-2 ma-0" 
                                        @click="showCalendar = !showCalendar" 
                                        :class="{'btn-active': showCalendar}"
                                        v-bind="attrs"
                                        v-on="on">
                                    </v-img>
                                </template>
                                    <span class="select-range">
                                        {{$t('selectTimeRange')}}
                                    </span>
                            </v-tooltip>                        
                        </v-row>
                    </v-col>
                </v-row>
            </v-layout>
        </v-card-title>
  
    <div class="range" v-if="showCalendar">
        <p class="text-right mr-2 mb-0 close"  @click="showCalendar = false">X</p>
        <p style="text-align:center" class="pb-0 mb-0 from-to-calendar">{{fromDate()}} <span v-if="startDate !== '' && range !== 'day' && range !== ''" class="pb-0 mb-0"> - {{toDate()}}</span></p>
        <v-radio-group v-model="range" row class="radio-group pt-0 mt-0">
            <v-radio label="Dia" value="day" class="option"></v-radio>
            <v-radio label="Semana" value="week" class="option"></v-radio>
            <v-radio label="Mes" value="month" class="option"></v-radio>
        </v-radio-group>
        
    </div>
    <v-date-picker v-if="showCalendar" v-model="startDate" elevation="15" class="calendar" :locale="lang" :allowed-dates="allowedDates"
    ></v-date-picker>
    </v-card>
  </v-container>
</template>

<script>
import calendar from '@/assets/imgs/calendar.png';
export default {
  components:{

  },
  data () {
    return {
      showCalendar: false,
      calendar,
      lang: "",
    }
  },
  mounted(){
   
  },
  created(){
      this.lang = this.$t('calendarLanguage')
  },
  computed:{
    startDate: {
        get(){
            return this.$store.getters.getStartDate
        },
        set(value){
            return this.$store.commit('setStartDate', value)
        }
    },
    range: {
        get(){
            return this.$store.getters.getRange
        },
        set(value){
            return this.$store.commit('setRange', value)
      }
    }
  },
  beforeDestroy(){

  },
  methods: {
    fromDate(){
        if(this.startDate !== ''){
            let date = new Date(this.startDate);
            date.setDate(date.getDate()+1)
            return date.toLocaleString().split(' ')[0]
        } else{
            return ''
        }
    },
    toDate(){
        let date = new Date(this.startDate);
        if(this.range === 'month'){
            date.setDate(date.getDate()+30)
            let newDate = date.toLocaleString().split(' ')[0]
            return newDate
        } else if(this.range === 'week'){
            date.setDate(date.getDate()+7)
            let newDate = date.toLocaleString().split(' ')[0]
            return newDate
        } else{
            return ''
        }
    },
    allowedDates(val){
      return new Date(val) <= new Date() 
    } 
  }
  
}
</script>
<style>
    

    .table-container{
        max-width: 98%!important;
        margin-left: 20px!important;
        margin-right: 20px!important;
    }
    .size-card-calendar{
        padding: 0 40px!important;
    }
    .title-statistics{
        font-size:16px!important;
        font-family: 'Roboto', 'sans-serif';
        color: #0d5ae5!important;
        display: inline-block!important;
    }
    .statistics-filter{
        max-width: 20%!important;
        font-size: 14px!important;
        display: inline-block!important;
        color: #0d5ae5!important;
        font-weight: normal;
    }
    .statistics-filter .v-select__selection--comma{
        margin: 0!important;
    }
    .time-filter{
        max-width: 100%!important;
    }
    .calendar{
        position: absolute!important;
        z-index: 20!important;
        right: 50px!important;
        top: 140px!important;
    }
    .time-filter{
        max-width: 100%!important;
    }
    .mj-daterange-picker .panels-choices{
        grid-template-columns: 1fr 1fr 1fr!important;
        padding: 10px!important;
    }
    .mj-daterange-picker .preset-ranges .preset{
        width: 25%!important;
        margin: 0!important;
        text-align: center!important;
        vertical-align: center!important;
        font-size: 10px!important;
    }
    .mj-daterange-picker .preset-ranges{
        padding: 10px!important;
    }
    .mj-calendar{
        padding: 10px!important;
    }
    .mj-calendar .calendar-days .day{
        height: 30px!important;
    }
    .mj-calendar .calendar-months .month{
        height: 30px!important;
    }
    .calendar{
        position: absolute!important;
        z-index: 20!important;
        right: 50px!important;
        top: 140px;
    }
    .range{
        position: absolute!important;
        z-index: 20!important;
        right: 50px!important;
        top: 52px!important;
        width: 290px!important;
        background-color: #fff;
        border: 2px solid rgb(233, 233, 233);
    }
    .option .mdi-radiobox-blank{
        font-size: 15px!important;
    }
    .option .v-label{
        font-size: 12px!important;
    }
    .radio-group .v-input--radio-group__input{
        justify-content: center!important;
    }
    .v-application .accent{
        background-color: #0d5ae5!important;
        border-color: #0d5ae5!important;
    }
    .v-application .accent--text{
        color: #0d5ae5!important;
        caret-color: #0d5ae5!important;
    }
    .btn-calendar{
      background-color: #fff!important;
      font-size: 14px!important;
      font-weight: normal!important;
      display: inline-block!important;
      align-self: center!important;
      margin: 0!important;
      padding: 0!important;
    }
    .calendar-title{
      padding: 0!important;
    }
    .btn-active{
        filter: brightness(0.5) sepia(5) hue-rotate(170deg) saturate(10);
        background-color: transparent!important;
    }
    .img-icon{
        cursor: pointer!important;
    }
    .close{
        cursor: pointer!important;
        font-size: 14px!important;
    }
    .statisticsForDate{
        font-weight: 500!important;
        font-size: 14px!important;
        color: #333!important;
    }
    .date{
        font-weight: normal!important;
        font-size: 14px!important;
        color: #888;
    }
    .statistics-for-date{
        align-self: center!important;
        display: flex!important;
        justify-content: flex-end!important;
    }
    .date{
        text-align: center!important;
    }
    .statistics-for-date-calendar{
        justify-content: flex-end!important;
    }
    .from-to-calendar{
        font-size: 14px!important;
        margin-top: -8px!important;
    }
    .stat-col.col-sm-7{
        margin-left: -15px!important;
    }
    @media (max-width: 1450px) {
        .v-date-picker-title__date{
            font-size: 23px!important;
        }
        .filter {
            max-width: 50% !important;
        }
        .select {
            width: 50% !important;
        }
    }

    @media (max-width: 1200px) {
        .v-date-picker-title__date{
            font-size: 18px!important;
        }
    }
    @media (max-width: 1000px) {
        .size-card{
            padding-left: 0px!important;
            padding-right: 30px!important;
        }
        .from-to-calendar{
            font-size: 12px!important;
        }
        .statisticsForDate{
            font-size: 13px!important;
        }
        .btn-calendar{
            font-size: 13px!important;
        }
        .img-icon{
            max-width: 31px!important;
        }
        .date{
            font-size: 13px!important;
        }
    }
    @media (max-width: 960px) {
        .row-calendar .row{
            justify-content: flex-start!important;
        }
        .calendar-col{
            margin-top: 0px!important;
        }
    }
    @media (max-width: 800px) {
        .statisticsForDate{
            font-size: 12px!important;
        }
        .btn-calendar{
            font-size: 12px!important;
        }
        .img-icon{
            max-width: 28px!important;
        }
        .date{
            font-size: 12px!important;
        }
    }
    @media (max-width: 690px) {
        .stat-col.col-sm-7{
            flex: 0 0 100%!important;
            max-width: 100%!important;
        }
        .statistics-for-date-calendar{
            justify-content: flex-start!important;
        }
        .calendar-col.col-sm-5{
            flex: 0 0 100%!important;
            max-width: 100%!important;
        }
    }
    
    @media (max-width: 600px) {
        .table-container {
            margin-left: 5px!important;
            max-width: 120%!important;
        }
        .row-calendar .row{
            margin-left: -20px!important;
        }
        .size-card{
            padding-right: 0px!important;
        }
        .calendar-col{
            margin-left: 10px!important;
        }
    }
    @media (max-width: 571px) {
        .calendar-col{
            margin-top: 28px!important;
        }
    }
    @media (max-width: 390px){
        .range{
            width: 280px!important;
        }
    }
    @media (max-width: 380px){
        .btn-calendar{
            font-size: 12px!important;
        }
        .img-icon{
            max-width: 25px!important;
        }
        .range{
            width: 270px!important;
        }
        .calendar-col{
            margin-top: 28px!important;
            margin-left: 10px!important;
        }
    }
    @media (max-width: 370px){
        .range{
            width: 260px!important;
        }
    }
    
</style>
